import { z } from "zod"

const GenerateLandingPagesStatus = z.enum([
  "NOT_STARTED",
  "ABORTED",
  "FAILED",
  "PENDING_REDRIVE",
  "RUNNING",
  "SUCCEEDED",
  "TIMED_OUT",
])

export const GenerateLandingPagesState = z.object({
  status: GenerateLandingPagesStatus,
  taskResults: z
    .object({
      release: z
        .object({
          id: z.string(),
        })
        .optional(),
    })
    .optional(),
})

export type GenerateLandingPagesState = z.infer<
  typeof GenerateLandingPagesState
>
